module.exports = ".list li{\r\n    list-style-type: none;\r\n    margin-bottom: 15px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-grid/psa-licence-req-grid.component.css
// module id = ./src/app/pages/functions/psadetails/psa-list/psa-licence-request/psa-licence-req-grid/psa-licence-req-grid.component.css
// module chunks = main